import React, {useContext, useEffect, useState} from 'react';

import {TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,
  ExportRowRenderer,
  ListCustomFilterRenderer,
  ListOrderBy,
  ListRowRenderer
} from "../../common/AbstractListView";

import constants from '../../../constants';

import {containerStatusList} from '../tableSettings';
import {Search} from "../../../filtering";

import {
  DateRenderer,
  DateTimeRenderer,
  FloatRenderer,
  NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,
  TextAlignRightRenderer,
  TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import JobListViewContext, { IJobListViewContext, RightClickContext } from '../../common/JobListViewContext';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import {JobNames} from '../../../framework.core/JobNames';
import {OiContainerListItem} from '../../../fms.data/models/OiContainerListItem';
import * as XCol from '../../../framework.core/XExportColumn';
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../../ui/ActionButton';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import IfmsModal from '../../../ui/IfmsModal';
import { formatDate } from '../../../dateUtils';
import Date from '../../../ui/Date';
import SecondaryButton from '../../../ui/SecondaryButton';
import { SQLField, SQLInfo, SQLType } from '../../../framework.core/data/SQLInfo';
import { ApiResult, InsertResultsWithData } from '../../../framework.core/data/ApiResult';
import fastStorage from '../../../fastStorage';
import _ from 'lodash';
import { OmContainer } from '../../../fms.core/OmContainer';
import ApplicationContext from '../../../ApplicationContext';
import { RequestType } from '../../../fms.core/TrackRequest';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import TrackingRequest from '../../reports/TrackingRequest';
import EmailOptionPopup from '../../reports/EmailOption';
import { getFmsGlobal } from '../../../globals';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';//
import {useHistory} from 'react-router-dom';
import { NavigationType, openNewPage } from '../../../util/navigationHelpers';
import { LastEventRenderer, RQFilterRenderer } from '../../common/commonListRenderers';
import cntrBlack from '../../../img/container_tracking-black.svg';
import cntrWhite from '../../../img/container_tracking-white.svg';
import PrimaryInverseButton from '../../../ui/PrimaryInverseButton';

// function CntrNoRenderer({value, data, row}: any) {
//   const history = useHistory();
//   const jobListContext = useContext(JobListViewContext);

//   function switchToCntrFor() {
//     jobListContext.setFilterForScreenExternally('/common/joblistview/mbl/oceanImport', 
//       'containerNo', '', data[row.index].containerNo ?? '', 'update', false);
//     openNewPage(history, `/common/joblistview/mbl/oceanImport`, NavigationType.newPage);
//   }

//   return <PrimaryInverseButton onClick={switchToCntrFor} style={{width: '100%', color: 'blue', fontWeight: 'bold', fontSize: '10px', padding: '0 !important'}}>{value}</PrimaryInverseButton>
// }

let vcResult:string = '';

async function DoSave(rowId: number, dataIndex: any, datePopupInputValue: string|null, appContext: any, rowMblId:number) {
  //const [showGlobalOkDialog] = useGlobalOkDialog();

  let sqlInfo: SQLInfo = new SQLInfo({
    tableName: "T_OIMCONTAINER",
    type: SQLType.Update,
    fields: [
      new SQLField({ fieldName: `f_${dataIndex}`, propertyName: dataIndex, value: datePopupInputValue }),
    ],
    key: new SQLField({ fieldName: "F_Id", propertyName: "Id", value: rowId }),
  });

  const apiResult: ApiResult<InsertResultsWithData> = await appContext.api.updateContainerInfo(sqlInfo);

  const editModelKey = `editOiMbl${rowMblId}-/oceanImport/mbl/edit`;
  const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
  if (keyMatch) {
    const oimContainerArray = fastStorage[keyMatch].oimContainerList as OmContainer[];
    const oimContainer = oimContainerArray.find(x => x.id === rowId);
    if (oimContainer) {
      if (dataIndex === 'goDate')
        oimContainer.goDate = datePopupInputValue;
      else
        oimContainer.lastFreeDay = datePopupInputValue;
    }
  }
  

  if (apiResult && apiResult.success) {
    //await showGlobalOkDialog(<p>The data has been saved</p>);
  } else {
    //await showGlobalOkDialog(<div>
    //<p>Cannot save</p>
    //<p>{apiResult.message}</p>
    //</div>);
  }
}

function ClickAbleDateRenderer({ cell, data, row }: any) {
  const jobListContext = useContext(JobListViewContext);
  const l = data[row.index];

  function onDateCellClick() {
    if (jobListContext.rowExtrasId) {
      return; // Some row is already selected
    }

    jobListContext.setRowExtrasId(l.id);
    //jobListContext.setClickedCell(cell);
  }
  let content: React.ReactNode = <></>;
  if (cell.value)
    content = formatDate(cell.value);

  return (
    <div className="ifms-table-default" style={{ width: '100%', minHeight: '16px', cursor: 'pointer' }} onClick={onDateCellClick}>{content}</div>
  );
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as OiContainerListItem;
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const fmsGlobal = getFmsGlobal();
  const {switchToMbl} = useSelectedOperations();

  const items = [
    { label: 'Search', shortcut: 'F5', separator: false, newCol: false },
    { label: 'Go to MBL List', shortcut: 'F6', separator: true, newCol: false },
    { label: 'CNTR Tracking Info', shortcut: '', separator: false },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
  }));

  function openContainerTracking() {
    window.open(`https://trackinginfo.suntekscm.com/?licid=${fmsGlobal.AcmeID}&cntr=${selectedElement.containerNo}&email=${appContext.user?.email}`);
  }

  async function TrackRequestFunc(jobName: JobNames) {
    if (!selectedElement) {
      return;
    }

    if (_.isEmpty(selectedElement.containerNo)) {
      await showGlobalOkDialog(<p>Empty container number.</p>);
      return;
    }

    await CheckAndDoTrackRequest(jobName, selectedElement.id, selectedElement.trType, selectedElement.trStatus, selectedElement.mblNo)
  }

  async function CheckAndDoTrackRequest(jobName: string, jobId: number, trType: string, trStatus: string, mblNo: string, cntrCount: number = 1) {
    let result: string = '';
    if (!await CheckTrStatus(jobName, jobId, trType, trStatus, cntrCount)) return result;
    
    const apiResult = await IsShippingLineSupported(mblNo?.substring(0, 4), jobName === JobNames.OIMbl ? RequestType.bl : RequestType.Container)
    if (!apiResult.success || (jobName === JobNames.OIContainer && apiResult.result === RequestType.bl))
      return result;

    vcResult = apiResult.result;

    const errMsg = await CheckTrackRequestAllowed(cntrCount)
    if(!_.isEmpty(errMsg)){
      if (!errMsg.endsWith('?')){
        await showGlobalOkDialog(<p>{errMsg}</p>);
        return result;
      }
      else{
        const doClose = await showGlobalYesNoDialog(
          <div>
            <h3>{errMsg}</h3>
          </div>,false, 1
        );
  
        if (!doClose) {
          return result;
        }
      }
    }

    jobListContext.setRowExtrasId(jobId);
    jobListContext.setTrackingRequestEmailList('OpenEmailOptionPopup');
  }

  async function CheckTrackRequestAllowed(countToSend: number) {
    let result = '';

    const perMonth = appContext.suntekSettings?.company?.containersPerMonth ?? 0;
    if (perMonth > 0) {
      const apiResult = await appContext.api.checkThisMonthRequests();
      if (perMonth - apiResult < countToSend) {
        result = `Credit for containers per month is limited.
This request will cause additional fee.
Do you want to request this tracking?`;
      }
    }
    return result;
  }

  async function IsShippingLineSupported(vcScac: string, reqType: string) {
    let apiResult: ApiResult<string> = { success: false, result: '', message: '' };

    if (_.isEmpty(vcScac)) {
      await showGlobalOkDialog(<p>Vessel carrier was not given. Please retry with valid Master B/L number.</p>);
      return apiResult;
    }

    apiResult = await appContext.api.trackingCheckShippingLine(vcScac);

    if(!apiResult || !apiResult.success){
      await showGlobalOkDialog(<p>{apiResult?.message ?? constants.LOAD_ERROR_MESSAGE}</p>);
      return apiResult;
    }
    else {
      switch (apiResult.result) {
        case 'X':
          await showGlobalOkDialog(<p>Tracking Service does not support Vessel carrier {`[${vcScac}]`}.</p>);
          apiResult.success = false;
          break;
        case RequestType.bl:
          if (reqType !== RequestType.bl) {
            await showGlobalOkDialog(<p>Vessel carrier {`[${vcScac}] support only Master B/L tracking.`}
Please retry from Master B/L list.</p>);
            apiResult.success = false;
          }
          break;
      }
    }
    return apiResult;
  }

  async function CheckTrStatus(jobName: string, jobId: number, trType: string, trStatus: string, cntrCount: number = 1) {
    if (!_.isEmpty(trType)) {
      switch (jobName) {
        case JobNames.OIContainer:
          if (!(trStatus === "failed" || trStatus === "C")) {
            await showGlobalOkDialog(<p>Tracking service was already requested at {`[${trType === 'C' ? 'Container List' : 'Master B/L List'}].`}</p>);
            return false;
          }
          break;
        case JobNames.OIHbl:
          break;
        case JobNames.OIMbl:
          if(trType === 'C'){
            const apiResult = await appContext.api.getTrackRequestedContainerCountPerMbl(jobId);
            if(apiResult >= cntrCount){
              await showGlobalOkDialog(<p>All containers are already requested at {'['}Container List{']'}.</p>);
              return false;
            }
            else {
              await showGlobalOkDialog(<p>Part of containers are requested at [Container List].
You can request tracking service for the remaining containers
              </p>);
            }
          }
          else if (trType === 'M' && !(trStatus === "failed" || trStatus === "C")) {
            await showGlobalOkDialog(<p>Tracking service was already requested at [Master B/L List].</p>);
            return false;
          }
          break;
      }
    }
    return true;
  }


  function onMenuItemSelected(item: IfmsMenuItem) {
    switch (item.index) {
      case 0:
        jobListContext.triggerTableSearch('F5');
        break;
      case 1:
        switchToMbl();
        break;
      case 2:
        openContainerTracking();
        break;
      case 3:
        TrackRequestFunc(JobNames.OIContainer);
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function RefRenderer({value, data, row}: any) {
  const {switchToMblForDetail} = useOperations();

  return <PrimaryInverseButton onClick={() => switchToMblForDetail(data[row.index])} style={{width: '100%', lineHeight:'1em'}}>{value}</PrimaryInverseButton>
}

function CsListCommands() {
  return null;
}

function CsListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function formatData(data:Array<OiContainerListItem>) {
  return data;
}

function useOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);

  function switchToMblFor(c: OiContainerListItem | null) {
    if (!c) {
      return;
    }

    jobListContext.setFilterForScreenExternally('/common/joblistview/mbl/oceanImport', 
    'id', 'Ref. #', c.oiMblId, 'updated', false, true, null, 'refNo', c.refNo, false,true);
    
    openNewPage(history, `/common/joblistview/mbl/oceanImport`, NavigationType.newPage);
  }

  function switchToMblForDetail(c: OiContainerListItem | null) {
    if (!c) {
      return;
    }
    
    openNewPage(history, `/oceanImport/mbl/view/${c.oiMblId}`, NavigationType.newPage);
  }

  return {switchToMblFor, switchToMblForDetail};
}


function useSelectedOperations(){
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();

  const { switchToMblFor } = useOperations();

  function switchToMbl() {
    const selectedElement = jobListContext.selectedElement as OiContainerListItem;
    switchToMblFor(selectedElement);
  }

  return {switchToMbl};

}


function CsListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const jobListContext = useContext(JobListViewContext);
  const {switchToMbl} = useSelectedOperations();
  const [unprocessedFkey, setUnprocessedFkey] = useState<string|null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if(unprocessedFkey === "F6"){
      switchToMbl();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey:string) {
    if (['F6','F11'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.OIContainer}
      jobId={(jobListContext.selectedElement as OiContainerListItem|null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      //hideLogHistory={true}
    />
  );
}

function ContainerPopup({ rowId, onClose, cell, save }: { rowId: any, onClose: any, cell: any, save: any }) {
  const [datePopupInputValue, setDatePopupInputValue] = useState<string | null>(null);
  
  return (
    <IfmsModal isBlueHeader cancelOnEsc onCancel={onClose} draggable isOpen title={`Input - ${cell.column.Header}`} width="260px">
      <div className='report-popup'>
        <div style={{ height: '30px', display: 'flex' }}>
          <span>{cell.column.Header}</span>
          <div style={{ width: '80px', marginLeft: '10px', marginTop: '-1px' }}>
            <Date
              value={formatDate(datePopupInputValue)}
              onChange={date => { setDatePopupInputValue(date ?? null) }}
            />
          </div>
        </div>
        <div className="report-footer" >
          <SecondaryButton size="regular" focusable={true} onClick={() => { save(rowId, cell.column.dataIndex, datePopupInputValue) }}>
            SAVE
          </SecondaryButton>&nbsp;&nbsp;
          <SecondaryButton size="regular" focusable={true} onClick={onClose}>
            CANCEL
          </SecondaryButton>
        </div>
      </div>
    </IfmsModal>
  );
}

/**
 * Concrete implementation for Container List screen
 *
 * @class ContainerStatusListView
 * @extends {AbstractListView}
 */
 class ContainerStatusListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(JobNames.OIContainer, 'OiContainerListItem',
    OiContainerListItem.calculateSearchParameters(search, OiContainerListItem.MapSearchFields),
      1,
      search.pageSize);

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return { data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'trStatus',
        renderer: RQFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings, listCount: number, useDarkMode: boolean ): ListRowRenderer[] {
    const useTrackingService = suntekSettings?.company?.trackingService ?? false;
    return OiContainerListItem.getExportCollection(useTrackingService).map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      // if(x.dataIndex === 'containerNo') {
      //   colRenderer.Cell = CntrNoRenderer;
      //   colRenderer.Header = () => <span><u>Container No</u></span>;
      // }
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if(x.dataIndex === "stat") {
        colRenderer.Cell = () => <span></span>
        colRenderer.Header = () => <span></span>;
      }
      else if(x.dataIndex === "refNo") colRenderer.Cell = RefRenderer;
      else if(x.dataIndex === 'trStatus'){
        colRenderer.Cell = (props: any) => <LastEventRenderer {...props} jobName={JobNames.OIContainer} />;
        colRenderer.Header =  () => <div><img style={{float:'left'}} height="16px" src={useDarkMode ? cntrWhite : cntrBlack} alt='' />Container Tracking</div>;
      }
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if (x.type === XCol.XCellType.Date) {
        if (x.dataIndex === "eta")
          colRenderer.Cell = DateRenderer
        else {
          colRenderer.Cell = ClickAbleDateRenderer
        }
      }
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'pkgs')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} />;
        else
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
      }
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    colRenderer.push({ accessor: 'pkgs', changedValue: (value: any) => { return value['pkgs'] } });
    colRenderer.push({ accessor: 'bookingDate', changedValue: (value: any) => { return formatDate(value['bookingDate']) } });
    colRenderer.push({ accessor: 'ord', changedValue: (value: any) => { return formatDate(value['ord']) } });
    colRenderer.push({ accessor: 'inDate', changedValue: (value: any) => { return formatDate(value['inDate']) } });
    colRenderer.push({ accessor: 'loadDate', changedValue: (value: any) => { return formatDate(value['loadDate']) } });
    colRenderer.push({ accessor: 'atd', changedValue: (value: any) => { return formatDate(value['atd']) } });
    colRenderer.push({ accessor: 'ata', changedValue: (value: any) => { return formatDate(value['ata']) } });
    colRenderer.push({ accessor: 'unloadDate', changedValue: (value: any) => { return formatDate(value['unloadDate']) } });
    colRenderer.push({ accessor: 'carrierRls', changedValue: (value: any) => { return formatDate(value['carrierRls']) } });
    colRenderer.push({ accessor: 'customRls', changedValue: (value: any) => { return formatDate(value['customRls']) } });
    colRenderer.push({ accessor: 'rAtd', changedValue: (value: any) => { return formatDate(value['rAtd']) } });
    colRenderer.push({ accessor: 'inlandEta', changedValue: (value: any) => { return formatDate(value['inlandEta']) } });
    colRenderer.push({ accessor: 'rAta', changedValue: (value: any) => { return formatDate(value['rAta']) } });
    colRenderer.push({ accessor: 'lastFreeDay', changedValue: (value: any) => { return formatDate(value['lastFreeDay']) } });
    colRenderer.push({ accessor: 'puDate', changedValue: (value: any) => { return formatDate(value['puDate']) } });
    colRenderer.push({ accessor: 'outDate', changedValue: (value: any) => { return formatDate(value['outDate']) } });
    colRenderer.push({ accessor: 'dcDate', changedValue: (value: any) => { return formatDate(value['dcDate']) } });
    colRenderer.push({ accessor: 'emptyReturn', changedValue: (value: any) => { return formatDate(value['emptyReturn']) } });
    colRenderer.push({ accessor: 'etd', changedValue: (value: any) => { return formatDate(value['etd']) } });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'id',
      orderByAscending: false,
     };
   }

   renderRowExtras(rowId: number | null, context: IJobListViewContext, cell: any, appContext: any): React.ReactNode | null {
     if (!rowId) {
       return null;
     }

     function onClose() {
       context.setRowExtrasId(null);
     }

     function onCloseTracking49Popup() {
      const storageKey = `oi-container-trackrequest-${rowId}`;
      fastStorage[storageKey] = null;
      context.setRowExtrasId(null);
      context.setTrackingRequestEmailList(undefined);
      vcResult = '';
    }

     function onCloseEmailOptionPopup(emailList: string | undefined) {
       const storageKey = `emailoption-${rowId}`;
       fastStorage[storageKey] = null;
       if (_.isUndefined(emailList)) {
         context.setRowExtrasId(null);
         context.setTrackingRequestEmailList(undefined);
       }
       else
         context.setTrackingRequestEmailList(emailList);
    }

     function getTrackRequestTitle(trStatus: string) {
       return 'Tracking Request' + (!_.isEmpty(trStatus) && trStatus !== 'Q' ? ` - ${trStatus.toUpperCase().replace('_', ' ')}` : '');
     }

     function getEmailOptionTitle() {
       return `[Container #${cell.row.original.containerNo}] Tracking Request: Choose email notice recipients`;
     }

     function save(rowId: number, dataIndex: any, datePopupInputValue: string) {
       if (cell.value !== datePopupInputValue) {
         DoSave(rowId, dataIndex, datePopupInputValue, appContext, cell.row.original.oiMblId);
         onClose();
         context.reloadData();
       }
       else
         onClose();
     }
     
     if (!_.isUndefined(context.trackingRequestEmailList)) {
       if (context.trackingRequestEmailList === 'OpenEmailOptionPopup')
         return (
           <IfmsModal isBlueHeader cancelOnEsc onCancel={() => onCloseEmailOptionPopup(undefined)} draggable isOpen title={getEmailOptionTitle()} width="790px">
             <EmailOptionPopup
               jobId={rowId}
               storageKey={`emailoption-${rowId}`}
               onClose={onCloseEmailOptionPopup}
               jobName={JobNames.OIContainer}
               isUsedTrackingRequest={true}
             />
           </IfmsModal>
         );
       else {
         return (
           <IfmsModal isBlueHeader cancelOnEsc onCancel={onCloseTracking49Popup} draggable isOpen title={getTrackRequestTitle(cell.row.original.trStatus)} width="500px">
             <TrackingRequest
               jobId={rowId}
               storageKey={`oi-container-trackrequest-${rowId}`}
               onClose={onCloseTracking49Popup}
               jobName={JobNames.OIContainer}
               trStatus={cell.row.original.trStatus}
               trType={!_.isUndefined(context.trackingRequestEmailList) && context.trackingRequestEmailList !== 'OpenTrackRequestViewMode' ? (vcResult === RequestType.bl ? 'M' : 'C') : cell.row.original.trType}
               mode={!_.isUndefined(context.trackingRequestEmailList) && context.trackingRequestEmailList !== 'OpenTrackRequestViewMode' ? 'new' : 'view'}
               vcResult={vcResult}
               containerNo={cell.row.original.containerNo}
             />
           </IfmsModal>
         );
       }
     }
     else
       return <ContainerPopup rowId={rowId} onClose={onClose} save={save} cell={cell} />
   }

  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const tsettings = containerStatusList;
    const useTrackingService = suntekSettings?.company?.trackingService ?? false;
    const cols = OiContainerListItem.getExportCollection(useTrackingService);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });

    return tsettings;
    
  }

  getTableDomIdSuffix(): string {
    let domIdSuffix = ''; 
    if (this.suntekSettings?.company?.trackingService) domIdSuffix += '-trackingService';

    return domIdSuffix;
  }

  renderCommands() {
    return (
      <CsListCommands />
    );
  }

  renderBeforeConfigureButton() {
    return (
      <CsListToolbar />
    );
  }


  renderExtras() {
    return <CsListViewExtras />
  }

  getViewUrlFor() {
    return '';
  }

  getListViewTitle() {
    return 'Container List';
  };

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }
};

export default ContainerStatusListView;
